import { render } from "./AudioSectionLinkOnly.vue?vue&type=template&id=2f5c3e14&scoped=true"
import script from "./AudioSectionLinkOnly.vue?vue&type=script&lang=js"
export * from "./AudioSectionLinkOnly.vue?vue&type=script&lang=js"

import "./AudioSectionLinkOnly.vue?vue&type=style&index=0&id=2f5c3e14&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5c3e14"]])

export default __exports__